import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import { ngStorage } from 'ngstorage';
import * as _ from 'underscore';
import { NotificationService } from '../../../../../../../app.common/modules/common/services/notification.service';
import { ActiveExtrasFilter, ExtraItemBaseModel } from '../../../../../core';
import { ExtrasService } from '../../../../../extras/extras.service';
import { IProductExtraItemModel } from '../../../../models';

export interface IExtraItemModel extends ExtraItemBaseModel {
	IsSelected?: boolean;
}

class SelectExtras implements ng.IController {
	public static $inject = ['$translate', 'extrasService', 'notificationService', '$localStorage'];
	public selectExtrasForm: angular.IFormController;
	public resolve: {
		options: {
			selectedExtras: IProductExtraItemModel[]
		}
	};

	public selectedExtras: { [id: string]: IProductExtraItemModel } = {};
	public modalInstance: ng.ui.bootstrap.IModalInstanceService = this as any;

	public model = {
		extras: [] as IExtraItemModel[],
		searchTerm: null as string,
		waiting: true as boolean,
		noExtrasTitle: this.$translate.instant('extra_select_empty_list_title') as string,
		noExtrasMessage: this.$translate.instant('extra_select_empty_list_message') as string

	};

	public total: number = 0;
	public canSelectAll: boolean = true;
	public isSearch: boolean = false;
	public countryID: number;
	constructor(
		protected $translate: angular.translate.ITranslateService,
		public extrasService: ExtrasService,
		private notificationService: NotificationService,
		private $localStorage: ngStorage.StorageService
	) {
	}

	public $onInit(): void {
		this.resolve.options.selectedExtras.forEach((extra) => this.selectedExtras[extra.ID] = extra);
		this.loadExtras();
		this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
	}

	public searchKeyPressed($event: KeyboardEvent) {
		if ($event.which === 13 && !this.model.waiting) {
			this.search();
		}
	}

	public getImage(imageID: string) {
		return this.extrasService.getExtraImageUrl(imageID);
	}

	public selectExtra(extra: IExtraItemModel, $event: Event) {
		$event.preventDefault();
		$event.stopPropagation();
		extra.IsSelected = !extra.IsSelected;
		this.selectExtrasForm.$setDirty();
		if (this.selectedExtras[extra.ID]) {
			delete this.selectedExtras[extra.ID];
		} else {
			this.selectedExtras[extra.ID] = extra as IProductExtraItemModel;
		}
	}

	public search() {
		this.total = 0;
		this.loadExtras(true);
		this.isSearch = this.model.searchTerm !== null && this.model.searchTerm !== '';
	}

	public loadExtras(searchByTerm?: boolean) {
		if (this.total && this.model.extras.length === this.total) {
			return;
		}

		const filter: ActiveExtrasFilter = {
			SearchTerm: this.model.searchTerm,
			Limit: 20,
			SearchAfterID: this.model.extras.length && !searchByTerm ? _.last(this.model.extras).ID : null
		};

		this.model.waiting = true;
		this.notificationService.showWaitingMessage();

		return this.extrasService.getActiveExtras(filter)
			.then((response) => {
				this.total = response.Total;
				const extras: IExtraItemModel[] = response.Items;
				extras.forEach((extra) => {
					extra.IsSelected = !!this.selectedExtras[extra.ID];
				});
				if (searchByTerm) {
					this.model.extras = extras;
				} else {
					Array.prototype.push.apply(this.model.extras, extras);
				}
				this.model.waiting = false;

				if (this.model.extras.length) {
					return;
				}

				this.model.noExtrasTitle = this.model.searchTerm && this.model.searchTerm.length
					? this.$translate.instant('extras_not_found_title')
					: this.$translate.instant('extra_select_empty_list_title');
				this.model.noExtrasMessage = this.model.searchTerm && this.model.searchTerm.length
					? this.$translate.instant('extras_not_found_message', { search: this.model.searchTerm })
					: this.$translate.instant('extra_select_empty_list_message');
			})
			.catch((e) => this.notificationService.showErrorMessage(e))
			.finally(() => this.notificationService.clearAll());
	}

	public confirm = () => {

		const selectionResult = {
			status: 'ok',
			isAllSelected: false,
			selectedExtras: [] as ExtraItemBaseModel[]
		};

		selectionResult.selectedExtras = this.getSelectedExtras();
		this.modalInstance.close({ $value: selectionResult });
	}

	public getSelectedExtras = (): IExtraItemModel[] => this.model.extras.filter((extra) => extra.IsSelected);

	public dismiss = () => this.modalInstance.close({ $value: { status: 'close' } });
}

angular.module('naut').component('selectExtras', {
	template: require('./select-extras.component.html'),
	controller: SelectExtras,
	controllerAs: 'ctrl',
	bindings: {
		resolve: '<',
		close: '&',
		dismiss: '&'
	}
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/products/components/shared/product-extras-list/select-extras/select-extras.component.ts